import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';

import { UserService } from './core/user';
import { buildLocationRedirectUrl, pickLandingLocation } from './shared/navbar/location-utils';

@Injectable({
  providedIn: 'root'
})
export class LegacyLocationRedirectGuard implements CanActivate {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.userService.getUser().pipe(
      map((userData) => {
        // No location yet (e.g. user setup hasn't completed or failed) - nothing safe to
        // redirect to. Block navigation instead of crashing; app.component's userError$
        // banner covers surfacing the failure to the user.
        const target = pickLandingLocation(
          userData?.locations ?? [],
          userData?.userSettings?.favoriteLocations,
          this.userService.getCurrentSelectedLocation?.()
        );
        if (!target?.locationNumber) {
          return false;
        }
        return this.router.parseUrl(buildLocationRedirectUrl(target, state.url));
      })
    );
  }
}
